import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";

export class CareElementFilterSetting {
    public Key: string;
    public LabelKey: string;
    public IsEnabled: boolean;

    constructor(args: NonFunctionProperties<CareElementFilterSetting>) {
        Object.assign(this, args);
    }
}
